/* tslint:disable */
/* eslint-disable */
export enum WorkTodoStatusEnum {
  Offen = 'offen',
  InBearbeitung = 'in_bearbeitung',
  Erledigt = 'erledigt'
}
